var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{attrs:{"max-height":"150","max-width":"150","src":"https://oneworldbali.com/wp-content/uploads/2021/09/Logo-OWG-white-e1630293895573.png"}})],1)]),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }